export default __webpack_public_path__ + "static/B0264-28e3d8c87c4be653d3b7bd07cd6815d7.png";